module.exports = __webpack_public_path__ + "img/boluogulaorou.bce0616a.jpeg";